import {useStateContext} from "../../contexts/ContextProvider";
import {BuildingOffice2Icon, ChevronUpDownIcon} from "@heroicons/react/24/outline";

interface FacilitySwitcherProps {
    isCompactMode: boolean;
    onClick: () => void;
}

export default function FacilitySwitcher({isCompactMode, onClick}: FacilitySwitcherProps) {
    const {currentFacility, user} = useStateContext();

    // N'afficher que si l'utilisateur est admin d'un groupe (son facility d'origine est un groupe)
    // Note: is_group peut être 1 ou true selon l'API, donc on utilise Boolean()
    const isGroupAdmin = Boolean(user?.facility?.is_group);

    if (!currentFacility || !isGroupAdmin) {
        return null;
    }

    return (
        <div className="px-2 py-3">
            <button
                onClick={onClick}
                className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all duration-200 bg-gray-100 hover:bg-gray-200 text-gray-700 ${
                    isCompactMode ? 'justify-center' : ''
                }`}
            >
                <BuildingOffice2Icon className="h-5 w-5 flex-shrink-0 text-gray-500"/>
                {!isCompactMode && (
                    <div className="flex-1 min-w-0 text-left">
                        <p className="text-xs text-gray-500">Établissement</p>
                        <p className="text-sm font-medium truncate">{currentFacility.name}</p>
                    </div>
                )}
                {!isCompactMode && (
                    <ChevronUpDownIcon className="h-4 w-4 text-gray-400 flex-shrink-0"/>
                )}
            </button>
        </div>
    );
}
